import React, { useState, useEffect } from 'react'
import SegmentControlUpdated from 'app/views/components/segments/segment-control-updated'
import { Group, Stack } from '@mantine/core'
import { ToDoModal } from './todo/todo-modal'
import { useSelector } from 'react-redux'
import { getBusinessDate } from 'app/state/ducks/business-date/selectors'
import PrimaryInput from 'app/views/components/buttons/PrimaryInput'
import { ToDoPage } from './todo-page'
import { PaymentsPage } from './payments-page'
import { UnscheduledPage } from './unscheduled-page'
import { ScheduledPage } from './scheduled-page'
import { useDispatch } from 'react-redux'
import { loadBusinessDate } from 'app/state/ducks/business-date/thunks'
import { DatePickerInput } from '@mantine/dates';
import IonIcon from '@reacticons/ionicons'
import { useLocation } from 'react-router-dom'


//This keeps the date set when navigating between pages
let setDateRange: [Date, Date];
let useDateRange: boolean;

export function MyWorkDrillPage() {
  const dispatch = useDispatch()
  const location = useLocation()
  const [open, setOpen] = useState(false)
  const businessDate = useSelector(getBusinessDate)
  const [rangeDateFilter, setRangeDateFilter] = useState<[Date, Date]>(() => {
    const prevDay = new Date(businessDate)
    prevDay.setDate(prevDay.getDate() - 1)
    const nextDay = new Date(businessDate)
    nextDay.setDate(nextDay.getDate() + 1)
    return setDateRange || [prevDay, nextDay]
  });

  // The shell's one read (ADR_LOS-030): the business date the tabs are
  // framed on. Everything a child needs it fetches when it opens: the loan
  // row menu loads the index rate options it decides Rollover vs Conversion
  // from (loan-actions.tsx, on open), the Payments drawer loads the entities
  // it names lenders from, the loan and facility forms list wire instructions
  // themselves. Nothing on this page reads entity profiles, calendars or
  // contacts, so those tenant-wide lists are not loaded any more.
  // The tabs frame the servicing feed on it: they ask for the feed once this
  // mount's read has settled (loaded, or failed and fallen back to today),
  // not on the today-fallback first and again when it lands (LOS-7219). A
  // date left in the store by an earlier visit does not count: the read may
  // bring a newer one, and the feed would go out twice again.
  const [businessDateSettled, setBusinessDateSettled] = useState(false)
  useEffect(() => {
    Promise.resolve(dispatch(loadBusinessDate() as any)).finally(() =>
      setBusinessDateSettled(true),
    )
  }, [dispatch])

  const tabs: Record<string, { route: string; label: string; pageRender: JSX.Element }> = {
    todo: { route: '/mywork/todo', label: 'TO DO LIST', pageRender: <ToDoPage date={businessDate} /> },
    payments: { route: '/mywork/payments', label: 'PAYMENTS', pageRender: <PaymentsPage date={businessDate} useDateRange={useDateRange} dateRange={rangeDateFilter} /> },
    unscheduled: { route: '/mywork/unscheduled', label: 'UNSCHEDULED', pageRender: <UnscheduledPage date={businessDate} dateReady={businessDateSettled} useDateRange={useDateRange} dateRange={rangeDateFilter} /> },
    scheduled: { route: '/mywork/scheduled', label: 'SCHEDULED', pageRender: <ScheduledPage date={businessDate} dateReady={businessDateSettled} useDateRange={useDateRange} dateRange={rangeDateFilter} /> },
  }

  const tab = Object.entries(tabs).find(([, t]) => t.route === location.pathname)?.[0]
    ?? Object.keys(tabs)[0]

  function handleDateRangeChange(value: [Date, Date]): void {
    setDateRange = value
    setRangeDateFilter(value)
    useDateRange = true
  }

  return (
    <>
      <Stack w="100%">
        {/* this group is for segment control, gap, and calendar & Activity */}
        <Group w="100%" position="apart" className='tabsGapsActivity'>
          <Group position="right">
            <SegmentControlUpdated tabs={tabs} />
          </Group>
          <Group noWrap>
            {
              tab !== "todo" && <DatePickerInput
                className='myWorkDatePicker'
                w="250px"
                valueFormat='DD-MMM-YYYY'
                type="range"
                firstDayOfWeek={0}
                classNames={{
                  input: 'newInput',
                  wrapper: 'newInputWrapper',
                }}
                value={rangeDateFilter}
                onChange={handleDateRangeChange}
                rightSection={<IonIcon size="large" name="chevron-down-outline"></IonIcon>}
              />
            }

            <PrimaryInput className='activityButton' onClick={() => setOpen(true)}>Create To Do</PrimaryInput>
          </Group>
        </Group>
        {tabs[tab].pageRender}
      </Stack>
      <ToDoModal open={open} setOpen={setOpen} />
    </>
  )
}